module.exports = __webpack_public_path__ + "img/icon-search-button-purple.01a5fc4e.svg";